import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9fb91982&lang=true&"
import script from "./messenge.js?vue&type=script&lang=js&"
export * from "./messenge.js?vue&type=script&lang=js&"
import style0 from "../../../views/ChatView/chatview.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports